import { browser } from '$app/environment';

class AuthModal {
  visible = $state(false);
  showSignUp = $state(false);
  redirect = $state('');
  canShowOnboarding = $state(true);

  private onCloseListener: () => void;

  show(showSignUp = false, redirect = '', canShowOnboarding = true) {
    if (!browser) return;
    this.visible = true;
    this.showSignUp = showSignUp;
    this.redirect = redirect;
    this.canShowOnboarding = canShowOnboarding;
  }

  hide() {
    if (!browser) return;
    this.visible = false;
    this.showSignUp = false;
    if (this.onCloseListener) {
      this.onCloseListener();
    }
  }

  setOnCloseListener(listener: () => void) {
    this.onCloseListener = listener;
  }
}

export const authModal = new AuthModal();
